import WebsiteTestimonialCards from './WebsiteTestimonialCards';
import WebsiteTestimonialCard from './WebsiteTestimonialCard';

export default WebsiteTestimonialCards;

export {
  WebsiteTestimonialCard,
}



// WEBPACK FOOTER //
// ./src/components/admin/Website/Testimonials/index.js